import { IAstNode, IComparisonAstNode, IBetweenAndAstNode, IComposeFunc } from '../../typings/ast-node';
import { IComparisonToken } from '../../typings/token';
import { TokenComposeError } from '../../errors';



export function composeComparison(astNodes: IAstNode[], codes: string[], compose: IComposeFunc) {
  const index = astNodes.findIndex(({ type, token }) => {
    if (!token) { return false; }
    const { code } = token as IComparisonToken;
    return type === 'Temporary' && token.type === 'Comparison' && codes.includes(code);
  });
  if (index === -1) return;

  const node = astNodes[index];
  const token = node.token as IComparisonToken;
  if (token.code === 'BETWEEN-AND') {
    throw new TokenComposeError('invalid-comparsion-operator', '无效的AND操作符', token.position);
  } else if (['BETWEEN', 'ALL-BETWEEN', 'ANY-BETWEEN'].includes(token.code)) {
    const left = astNodes[index - 1];
    const andIndex = matchBetweenAnd(astNodes, index);

    if (!left) {
      throw new TokenComposeError('between-left-lost', 'BetweenAnd缺少被比较值', token.position);
    }
    if (andIndex === -1) {
      throw new TokenComposeError('between-and-lost', 'BetweenAnd缺少AND操作符', token.position);
    }
    const firstComparsionTokens = astNodes.slice(index + 1, andIndex);
    if (firstComparsionTokens.length !== 1) {
      throw new TokenComposeError('between-and-left-lost', 'BetweenAnd缺少左侧比较值', token.position);
    }
    const secondComparsionToken = astNodes[andIndex + 1];
    if (!secondComparsionToken) {
      throw new TokenComposeError('between-and-right-lost', 'BetweenAnd缺少右侧比较值', token.position);
    }


    const leftNode = compose([left]);
    const andLeftNode = compose([firstComparsionTokens[0]]);
    const andRightNode = compose([secondComparsionToken]);

    const astNode: IBetweenAndAstNode = {
      type: 'Comparison',
      operator: token.code,
      token,
      left: leftNode,
      andLeft: andLeftNode,
      andRight: andRightNode,
      children: [leftNode, node, andLeftNode, astNodes[andIndex], andRightNode]
    };

    astNodes.splice(index - 1, 5, astNode);

    composeComparison(astNodes, codes, compose);
  } else if (codes.includes(token.code)) {
    const left = astNodes[index - 1];
    const right = astNodes[index + 1];
    const node = astNodes[index];

    if (!left && !right) {
      throw new TokenComposeError('incomplete-expression', '缺少比较值', node.token!.position);
    } else if (!left) {
      throw new TokenComposeError('incomplete-expression', '缺少左侧比较值', node.token!.position);
    } else if (!right) {
      throw new TokenComposeError('incomplete-expression', '缺少右侧比较值', node.token!.position);
    }

    const leftNode = compose([left]);
    const rightNode = compose([right]);

    const astNode: IComparisonAstNode = {
      type: 'Comparison',
      operator: token.code,
      token,
      left: leftNode,
      right: rightNode,
      children: [leftNode, node, rightNode]
    };

    astNodes.splice(index - 1, 3, astNode);

    composeComparison(astNodes, codes, compose);
  }
}



function matchBetweenAnd(astNodes: IAstNode[], betweenIndex: number) {
  let i = betweenIndex + 1;
  let matched = false;
  while (i < astNodes.length) {
    const { type, code } = astNodes[i].token as IComparisonToken;
    if (type === 'Comparison' && code === 'BETWEEN-AND') {
      matched = true;
      return i;
    }
    i++;
  }

  if (!matched) {
    return -1;
  }
  return i;
}
